<template>
	<div id="app" class="u-flex">
		<app-header></app-header>
		<div class="o-container u-flex u-flex-width">
			<div class="o-layout o-layout--spacing-large u-flex">
				<div class="o-box o-box--spacing-regular o-layout__item u-10/12 u-offset-1/12 u-background-white u-flex">
                    <transition 
                        name="change"
                        enter-active-class="anim-enter"
                        leave-active-class="anim-out" 
                        mode="out-in">
					   <router-view></router-view>
                    </transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import appHeader from '@/components/app-header/app-header'

export default {
	name: 'app',
	components: {
		appHeader
	},
	created() {
		this.$store.dispatch('getAuthors')
		this.$store.dispatch('getPosts')
	}
}
</script>

<style lang="scss">
    
.change-enter-active, .change-leave-active {

}
.change-enter, .change-leave-to /* .fade-leave-active below version 2.1.8 */ {

}
    
.anim-enter {
    animation: anim-enter 1s cubic-bezier(0.77, 0, 0.175, 1);
}
    
.anim-out {
    animation: anim-out 1s cubic-bezier(0.77, 0, 0.175, 1);
}
    
@keyframes anim-enter {
  0% {transform: translateY(150vh) scale(.8)}
  50% {transform: translateY(0vh) scale(.8)}
  100% {transform: translateY(0vh)  scale(1)}
}

@keyframes anim-out {
  0% {transform: translateY(0vh) scale(1)}
  50% {transform: translateY(0vh) scale(.8)}
  100% {transform: translateY(150vw)  scale(.8)}
}

// Settings
@import "../node_modules/orioncss/01 - settings/settings.breakpoints"; 
@import "../node_modules/orioncss/01 - settings/settings.spacing";
@import "../node_modules/orioncss/01 - settings/settings.typography";
@import "../node_modules/orioncss/01 - settings/settings.widths";
@import "../node_modules/orioncss/01 - settings/settings.grid-system";
@import "/assets/sass/01 - settings/settings.colors";

// Tools
@import "../node_modules/orioncss/02 - tools/tools.clearfix";
@import "../node_modules/orioncss/02 - tools/tools.color";
@import "../node_modules/orioncss/02 - tools/tools.rem";
@import "../node_modules/orioncss/02 - tools/tools.responsive-breakpoints";
@import "../node_modules/orioncss/02 - tools/tools.spacing";

// Generic
@import "../node_modules/normalize.css/normalize";
@import "../node_modules/orioncss/03 - generic/generic.reset";
@import "../node_modules/orioncss/03 - generic/generic.box-sizing";

// Elements
@import "../node_modules/orioncss/04 - elements/elements.headings";
@import "../node_modules/orioncss/04 - elements/elements.images";
@import "../node_modules/orioncss/04 - elements/elements.lists";
@import "../node_modules/orioncss/04 - elements/elements.paragraphs";
@import "/assets/sass/04 - elements/elements.page";
@import "/assets/sass/04 - elements/elements.links";

// Objects
@import "../node_modules/orioncss/05 - objects/objects.box";
@import "../node_modules/orioncss/05 - objects/objects.container";
@import "../node_modules/orioncss/05 - objects/objects.cover";
@import "../node_modules/orioncss/05 - objects/objects.expander";
@import "../node_modules/orioncss/05 - objects/objects.layout";
@import "../node_modules/orioncss/05 - objects/objects.list-bare";
@import "../node_modules/orioncss/05 - objects/objects.list-inline";
@import "../node_modules/orioncss/05 - objects/objects.media";
@import "../node_modules/orioncss/05 - objects/objects.table"; 

// Components
// Sample component can be found in /node_modules/orioncss/06 - components/
@import "components/app-button/components.button";
@import "components/logo/components.logo";
@import "components/type/components.type";
@import "components/icons/components.icons";
@import "components/post/components.post";
@import "components/navigation/components.navigation";

// Utilities
@import "../node_modules/orioncss/07 - utilities/utilities.alignments";
@import "../node_modules/orioncss/07 - utilities/utilities.backgrounds";
@import "../node_modules/orioncss/07 - utilities/utilities.cursor";
@import "../node_modules/orioncss/07 - utilities/utilities.display-hide";
@import "../node_modules/orioncss/07 - utilities/utilities.fills";
@import "../node_modules/orioncss/07 - utilities/utilities.floats";
@import "../node_modules/orioncss/07 - utilities/utilities.heights";
@import "../node_modules/orioncss/07 - utilities/utilities.hidden-visually";
@import "../node_modules/orioncss/07 - utilities/utilities.margins";
@import "../node_modules/orioncss/07 - utilities/utilities.nudges";
@import "../node_modules/orioncss/07 - utilities/utilities.paddings";
@import "../node_modules/orioncss/07 - utilities/utilities.position";
@import "../node_modules/orioncss/07 - utilities/utilities.truncate";
@import "../node_modules/orioncss/07 - utilities/utilities.typography";
@import "../node_modules/orioncss/07 - utilities/utilities.user-select";
@import "../node_modules/orioncss/07 - utilities/utilities.widths";
@import "../node_modules/orioncss/07 - utilities/utilities.z-index";
@import "/assets/sass/07 - utilities/utilities.flex";

</style>


// WEBPACK FOOTER //
// App.vue?4bd5586b